export default __webpack_public_path__ + "static/media/coffeeIcon.53a1ce6b.jpg";